export function hasAllPermissions(userPermissions = [], permissions = []) {
  return permissions.every(permission => userPermissions.includes(permission));
}

export function hasAnyPermission(userPermissions = [], permissions = []) {
  return permissions.some(permission => userPermissions.includes(permission));
}
